<div class="contents-area" (dragstart)="onDragstartBody($event)">

  <div class="element-column">
    <div class="column-list">
      <label class="list-input-title">受注コード</label>
      <div class="list-input-content">
        <app-order-code-text-input
          id="txti_OrderCodeFr" #txti_OrderCodeFr [subid]="'txti_OrderCodeFr'" [(ngModel)]="kymw6500Model.orderCodeFr"
          [required]="true" [catalogIDField]="lbl_CatalogIdFr" [initFocusItem]="txti_OrderCodeFr"
          (ngModelChange)="eventOrderCodeFr_CHANGEHandler()"
          [forcedEnabledMode]="'true'" [tabindex]="0" style="width: 7rem;">
        </app-order-code-text-input>
        <label>～</label>
        <app-order-code-text-input id="txti_OrderCodeTo"
          [subid]="'txti_OrderCodeTo'" [catalogIDField]="lbl_CatalogIdTo" text="" [initFocusItem]="txti_OrderCodeFr"
          [forcedEnabledMode]="'true'" [(ngModel)]="kymw6500Model.orderCodeTo" [tabindex]="0" #txti_OrderCodeTo
          (ngModelChange)="eventOrderCodeTo_CHANGEHandler()">
        </app-order-code-text-input>
      </div>

      <label class="list-input-title">配達企画回（翌週）</label>
      <div class="list-input-content">
        <input type="text" class="deliv-catalog" id="lbl_CatalogIdFr" #lbl_CatalogIdFr readonly>
        <label>～</label>
        <input type="text" class="deliv-catalog" id="lbl_CatalogIdTo" #lbl_CatalogIdTo readonly>
      </div>

      <label class="list-input-title">カテゴリ</label>
      <div class="list-input-content">
        <app-cws-plan-category-code-combo-box id="cmb_CategoryCode" style="width: 300px"
          [subid]="'cmb_CategoryCode'" [categoryLevel]="1" stockLimitFlg="1" [initFocusItem]="txti_OrderCodeFr"
          [forcedEnabledMode]="'true'" [tabindex]="0" #cmb_CategoryCode [(ngModel)]="kymw6500Model.categoryCode"
          (change)="eventCategoryCode_CHANGEHandler()">
        </app-cws-plan-category-code-combo-box>
      </div>
    </div>
    <button id="btn_Display" class="btn-secondary" #btn_Display (click)="eventDisplay_CLICKHandler()" forcedEnabledMode="none" [tabindex]="0" >表示</button>
  </div>

  <div>
    <wj-flex-grid id="dtg_TimeSaleList" #dtg_TimeSaleList [itemsSource]="kymw6500Model.timeSaleList"
      [isReadOnly]="true" forcedEnabledMode="true" (itemsSourceChanged)="onItemsSourceChanged()" [tabindex]="0" >
      <wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'受注コード'" [binding]="'OrderCode'"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="160" [header]="'配達企画回（翌週）'" [binding]="'DelivCatalogId'"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="355" [header]="'カテゴリ'" [binding]="'CategoryCodeName'"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'開始日時'" [binding]="'StartDate'"></wj-flex-grid-column>
      <wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'終了日時'" [binding]="'EndDate'"></wj-flex-grid-column>
    </wj-flex-grid>
  </div>
</div>

<footer class="footer-buttons">
  <button class="btn-primary" id="btn_Entry" (click)="eventEntry_CLICKHandler()" forcedEnabledMode="" [tabindex]="0" >登録</button>
</footer>
